<template>
  <div class="space-y-2">
    <div class="bg-gray-800 rounded text-sm hover:bg-gray-700">
      <div>
        <div class="p-4 space-y-4">
          <div class="flex -mx-4 justify-between items-center">
            <div class="text-white flex-1 px-4">
              <span class="text-gray-400 text-xs">{{ dateCreated }}</span>
              <h5 class="text-sm font-semibold tracking-wide">
                {{ order.name }}
              </h5>
              <span v-if="supplier" class="text-gray-400 text-xs">{{ supplier.name }}</span>
            </div>
            <div v-if="$isAdminOrSuperAdmin" class="text-white w-32 px-4">
              {{ order.price }} &euro;
            </div>
            <div class="w-48 text-right px-4">
              <OrderStatusManager :order-id="order.uuid" :status="order.order_status" />
            </div>
            <div class="text-white w-64 px-4 text-right">
              <BaseButton
                tag="router-link"
                primary
                outline
                small
                type="button"
                :to="{
                  name: 'accounts.orders.show',
                  params: {
                    accountId: $route.params.accountId,
                    orderId: order.uuid,
                  },
                }"
              >
                Go to Order
              </BaseButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pl-8 space-y-2">
      <OrderItem
        v-for="orderItem in projectRelatedRootOrderItems"
        :key="orderItem.uuid"
        :order-item="orderItem"
        :force-order-items-visibility="forceOrderItemsVisibility"
        :force-requirements-visibility="forceRequirementsVisibility"
        :force-tasks-visibility="forceTasksVisibility"
        @updated:task="load"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import OrderItem from './OrderItem.vue';
import OrderStatusManager from './OrderStatusManager.vue';

export default {
  name: 'Order',
  components: {
    OrderItem,
    OrderStatusManager,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
    forceOrderItemsVisibility: Boolean,
    forceRequirementsVisibility: Boolean,
    forceTasksVisibility: Boolean,
  },
  computed: {
    supplier() {
      return this.$store.state.entities.accounts.byId[this.order.supplierUuid] || null;
    },
    orderItems() {
      return this.$store.getters['ui/orderOrderItems/orderItemsByOrder'](this.order.uuid);
    },
    rootOrderItems() {
      return this.orderItems.filter((x) => !x.parentOrderItemUuid);
    },
    projectRelatedRootOrderItems() {
      return this.rootOrderItems.filter((orderItem) => orderItem.projectId === this.project.uuid);
    },
    dateCreated() {
      return moment(this.order.createdAt).format('DD/MM/YYYY');
    },
  },
  created() {
    this.load();
  },
  destroyed() {
    this.$store.dispatch('ui/orderOrderItems/clear', { orderId: this.order.uuid });
  },
  methods: {
    async load() {
      try {
        await Promise.all([
          this.$store.dispatch({
            type: 'ui/orderOrderItems/load',
            orderId: this.order.uuid,
            params: {
              include: 'orderable,linksCount,notesCount,mediaCount',
            },
          }),
        ]);
      } catch (error) {
        //
      }
    },
  },
};
</script>
